import { OrganizationGroupRole, User, UserRole } from 'generated-graphql/types';
import { UserOrganizationState } from 'services/userOrganization/atom';

type Props = {
  isHomeTabHidden: boolean;
  user: Pick<User, 'organizationGroupRole'> | null;
  userOrganization: Pick<
    UserOrganizationState,
    'organizationId' | 'role'
  > | null;
  organizationId: string | undefined;
};

// Hides Home only from known non-admins: while a role loads, or if it fails
// to, Home stays.
export const getIsHomeHidden = ({
  isHomeTabHidden,
  user,
  userOrganization,
  organizationId
}: Props) => {
  if (!isHomeTabHidden || !user) return false;

  if (
    user.organizationGroupRole === OrganizationGroupRole.OrganizationGroupAdmin
  ) {
    return false;
  }

  // No group role means the per-organization role is never fetched.
  if (!user.organizationGroupRole) return true;

  return (
    !!organizationId &&
    userOrganization?.organizationId === organizationId &&
    userOrganization.role !== UserRole.Admin
  );
};
